'use es6';

export const getEmail = state => state.contact.email;